/**
 * @generated SignedSource<<93674351da57ce265f851e44e82b8424>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberReportContentUsagesAverageVideoWatchProgressStatisticsCardFragment$data = {
  readonly contentUsagesAverageVideoWatchProgressReport: {
    readonly allTime: number;
  };
  readonly " $fragmentType": "MemberReportContentUsagesAverageVideoWatchProgressStatisticsCardFragment";
};
export type MemberReportContentUsagesAverageVideoWatchProgressStatisticsCardFragment$key = {
  readonly " $data"?: MemberReportContentUsagesAverageVideoWatchProgressStatisticsCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberReportContentUsagesAverageVideoWatchProgressStatisticsCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberReportContentUsagesAverageVideoWatchProgressStatisticsCardFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "concreteType": "GenericReportingResponse",
      "kind": "LinkedField",
      "name": "contentUsagesAverageVideoWatchProgressReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationMembership",
  "abstractKey": null
};

(node as any).hash = "523605b6f0aadfae0450814e0b6923aa";

export default node;
